import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import AuthService from 'Lib/API/Auth';
import { useAuth0 } from '@auth0/auth0-react';
import { toastr } from 'react-redux-toastr';
import AddNewTag from 'pages/Members/MemberDetails/AddNewTag';
import AddTagField from 'pages/Members/MemberDetails/AddTagField';

function CreateArea({
  rows,
  handleAdd,
  editNote,
  setEditNote,
  noteToEdit,
  setNoteToEdit,
  refresh,
  setRefresh,
  setLoading,
}) {
  const { getAccessTokenSilently } = useAuth0();
  const [openTag, setOpenTag] = useState(false);
  const [tags, setTags] = useState([]);

  const [note, setNote] = useState({
    title: '',
    content: '',
  });

  useEffect(() => {
    if (noteToEdit) {
      setNote({
        content: noteToEdit.note,
      });
      setTags([...(noteToEdit.tags || [])]);
    }
  }, [noteToEdit?._id]);

  function handleChange(event) {
    var { name, value } = event.target;
    setNote((prevValue) => {
      if (name === 'title') {
        return { title: value, content: prevValue.content };
      } else if (name === 'content') {
        return { title: prevValue.title, content: value };
      }
    });
  }

  const resetForm = () => {
    setNote({
      title: '',
      content: '',
    });
    setTags([]);
  };

  const handleEdit = async () => {
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const data = {
        noteIds: noteToEdit._id,
        note: note.content,
        tags,
      };
      await AuthService.editNote(data, token);
      toastr.success('Success', 'Note edited successfully');
    } catch (error) {
      toastr.error('Error', error?.data?.message);
    } finally {
      setRefresh(!refresh);
      setLoading(false);
      setEditNote(false);
      setNoteToEdit('');
    }
  };

  const handleClick = () => {
    if (editNote && noteToEdit?._id) {
      handleEdit();
      resetForm();
    } else {
      handleAdd(note.content, tags);
      resetForm();
    }
  };
  return (
    <div className="">
      <div className="add-note">Add Note</div>
      <div className="note-form">
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <textarea
            onChange={handleChange}
            name="content"
            placeholder="Type your note here..."
            rows={rows ? rows : '3'}
            maxLength={1000}
            value={note.content}
          />
          <AddTagField
            tags={tags}
            removeTagHandler={(tag) => setTags(tags.filter((t) => t !== tag))}
            fieldClickHandler={() => setOpenTag(true)}
          />
          <button onClick={handleClick}>
            {editNote && noteToEdit?._id ? 'Edit' : 'Add'}
          </button>
        </form>
      </div>
      <Dialog
        open={openTag}
        onClose={() => setOpenTag(false)}
        PaperProps={{
          style: {
            background: '#fff',
            borderRadius: '10px',
          },
        }}
      >
        <AddNewTag
          setOpenTag={setOpenTag}
          openTag={openTag}
          addTagHandler={(tag) =>
            setTags((prev) => (prev.includes(tag) ? prev : [...prev, tag]))
          }
          deleteTagHandler={(tag) =>
            setTags((prev) => prev.filter((t) => t !== tag))
          }
          selectedUserTag={tags}
          type="notes"
        />
      </Dialog>
    </div>
  );
}

export default CreateArea;
